import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { PricingModal } from './PricingModal';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Reservas',
    href: '#reservar'
  }, {
    name: 'Precios',
    href: '#',
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      setIsPricingModalOpen(true);
    }
  }, {
    name: 'Academia',
    href: '#academia'
  }, {
    name: 'Color',
    href: '#color'
  }, {
    name: 'Sobre Nosotros',
    href: '#sobre-mi'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a] border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-183" data-mp="emrh00xnisf8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-184" data-mp="olgp51zqwyia">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 group" data-id="element-185" data-mp="3n3w04c9oz5lt">
          <img src="https://cdn.magicpatterns.com/uploads/7vqxUAko1ojJpgDduvmLCg/heylloyd-image-1781198268359.png" alt="Ninja 2.0 Logo" className="h-10 w-auto object-contain mix-blend-screen group-hover:scale-105 transition-transform duration-300" width="70" height="70" fetchPriority="low" decoding="async" data-id="element-186" data-mp="3n1jadcxozqy7" />
          <span className="font-display text-2xl tracking-wider text-transparent bg-clip-text bg-gradient-to-b from-[#F3E08A] via-[#C9A24A] to-[#8A6A1E]" data-id="element-187" data-mp="39bzcakf23hv8">
            NINJA 2.0
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-188" data-mp="2wcyjg3g6ilip">
          <ul className="flex items-center gap-8" data-id="element-189" data-mp="2wacabzdn3xyd">
            {navLinks.map(link => <li key={link.name} data-id="element-190" data-mp="3b2xfo0o6bmvj">
                <a href={link.href} onClick={link.onClick} className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group" data-id="element-191" data-mp="361giog8t8kk8">
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-neon-violet to-neon-green transition-all duration-300 group-hover:w-full" data-id="element-192" data-mp="2dffat0xmv4wt" />
                </a>
              </li>)}
          </ul>
          <a href="#reservar" className="px-5 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-neon-violet/50 transition-all text-sm font-medium backdrop-blur-sm" data-id="element-193" data-mp="7juo6ynmkhc1">
            Agendar
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={mobileMenuOpen} data-id="element-194" data-mp="f4590xh274jc">
          {mobileMenuOpen ? <X size={24} data-id="element-195" data-mp="sva37k1nr4ma" /> : <Menu size={24} data-id="element-196" data-mp="svjrn37213pv" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 right-0 bg-[#0a0a0a]/95 backdrop-blur-xl border-b border-white/10 p-6 md:hidden flex flex-col gap-6" data-id="element-197" data-mp="xumpa2kpg7nt">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
        if (link.onClick) {
          link.onClick(e);
        }
        setMobileMenuOpen(false);
      }} className="text-lg font-medium text-gray-300 hover:text-white" data-id="element-198" data-mp="1gkumk41q43w3">
              {link.name}
            </a>)}
          <a href="#reservar" onClick={() => setMobileMenuOpen(false)} className="w-full py-3 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-center font-semibold text-white mt-4" data-id="element-199" data-mp="3b25syn99qfnq">
            Agendar Turno
          </a>
        </motion.div>}

      <PricingModal isOpen={isPricingModalOpen} onClose={() => setIsPricingModalOpen(false)} data-id="element-200" data-mp="1wzevat5zelj" />
    </nav>;
}